import { Parser, Retriever, IState, IMessageBus, sportMessage } from "../../../common";
import { InternalMessageBusChannels } from "sb-resp-lib";
import { SportModel } from "..";

export class SportParser implements Parser {
    private readonly messageBus: IMessageBus;
    private readonly retrievers: Retriever<SportModel>[];
    private readonly channelPrefix: string;
    private subscription = () => {};
    private isActive: boolean;

    constructor ( retrievers: Retriever<SportModel>[], messageBus: IMessageBus, channelPrefix: string) {
        this.messageBus = messageBus;
        this.retrievers = retrievers;
        this.channelPrefix = channelPrefix;
        this.isActive = false;
    }

    async activate(state: IState<SportModel>) {
        this.isActive = true;
        this.subscription = this.messageBus.getSubscription<sportMessage>(this.getCountUpdateChannel(),
        (message) => this.updateSelectedItemCount(state, message.data[0]), this);
        await Promise.all(
            this.retrievers.map(async r => {
              return await r.activate(state);
            })
        );
        if(this.isActive) {
            state.selectInitial();
        }
    }

    deactivate() {
        this.isActive = false;
        this.retrievers.forEach(r => r.deactivate());
        this.subscription();
    }

    private getCountUpdateChannel()
    {
        return `${this.channelPrefix}.${InternalMessageBusChannels.eventsList.count}`;
    }

    private updateSelectedItemCount(state: IState<SportModel>, message:sportMessage) {
        if (state.SelectedItemId !== message.sportId)
        {
            return;
        }
        const eventCount = message.eventsCount;
        if (eventCount > 0)
        {
            state.update(state.SelectedItemId, {numberOfEvents:eventCount}, true);
        }
        else
        {
            state.remove(state.SelectedItemId, true);
        }
    }
}